const initialstate = {
    data:[],
}


const MobdonationsReducer =  (state = initialstate, action:any)=>{
    switch (action.type){
        case 'fetch_data_success':
            return {... state, data:action.payload};
      
            default :
            return state;
    }
};
export default MobdonationsReducer;

;

